import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import Location from 'assets/icons/nucleo/18px_location.svg'
import Magnifier from 'assets/icons/nucleo/18px_magnifier-3.svg'
import { DateHeader } from './DateHeader'
import { HeaderInput } from './HeaderInput'
import {
  ButtonContainer,
  SearchButton,
  SearchElement,
  Separator,
  SearchBarHeader as StyledSearchBarHeader
} from './SearchBar.style'
import { SearchBarContext } from './SearchBarContext'

export type SearchTab = 'date' | 'location' | 'type' | null

interface SearchBarHeaderProps {
  forcedExpanded?: boolean
  expanded?: boolean
  handleOpen: (tab: SearchTab) => void
  hideSearchButton?: boolean
  close: () => void
  open?: boolean
  searchTab: SearchTab
}

export const SearchBarHeader = ({
  forcedExpanded,
  expanded,
  handleOpen,
  hideSearchButton,
  close,
  open,
  searchTab
}: SearchBarHeaderProps) => {
  const { t } = useTranslation(['home', 'common'])
  const {
    setLocationSearch,
    locationSearch,
    location,
    raceSearch,
    setRaceSearch,
    raceType,
    setRaceType,
    submitSearch
  } = useContext(SearchBarContext)

  const handleSubmit = () => {
    submitSearch()
    close()
  }

  const handleRaceSearch = (value: string) => {
    setRaceSearch(value)
    setRaceType({ facet: 'freeSearch', key: 'freeSearch', label: value })
  }

  return (
    <StyledSearchBarHeader $floating={!forcedExpanded} $expanded={expanded}>
      <SearchElement
        onClick={() => handleOpen('type')}
        $open={open}
        $selected={searchTab === 'type'}
        padding="0"
      >
        <HeaderInput
          value={raceType?.label || t('head.findRaceType')}
          searchLabel={raceSearch}
          setSearchLabel={handleRaceSearch}
          placeholder={t('head.findRaceType')}
          Icon={Magnifier}
          openOnMount={searchTab === 'type'}
          submit={handleSubmit}
          searchTab="type"
        />
      </SearchElement>
      <Separator />
      <SearchElement
        onClick={() => handleOpen('date')}
        $open={open}
        $selected={searchTab === 'date'}
        maxWidth="100%"
      >
        <DateHeader />
      </SearchElement>
      <Separator />
      <SearchElement
        onClick={() => handleOpen('location')}
        $open={open}
        $selected={searchTab === 'location'}
        padding="0"
      >
        <HeaderInput
          value={location?.name ?? t('head.findRaceLocation')}
          searchLabel={locationSearch}
          setSearchLabel={setLocationSearch}
          placeholder={t('head.findRaceLocation')}
          openOnMount={searchTab === 'location'}
          Icon={Location}
          searchTab={searchTab}
        />
      </SearchElement>
      {!hideSearchButton && (
        <ButtonContainer flexDirection="column">
          <SearchButton
            label={t('common:header.search')}
            onClick={handleSubmit}
          />
        </ButtonContainer>
      )}
    </StyledSearchBarHeader>
  )
}
